import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Users } from 'lucide-react';

export function ClientAcquisition() {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'New Clients',
        data: [4, 6, 5, 7, 8, 6],
        backgroundColor: 'hsla(var(--primary), 0.8)',
        borderRadius: 4
      },
      {
        label: 'Churned Clients',
        data: [1, 2, 1, 2, 1, 1],
        backgroundColor: 'hsla(var(--destructive), 0.8)',
        borderRadius: 4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 2
        }
      }
    }
  };

  return (
    <div className="theme-card p-6">
      <div className="flex items-center gap-3 mb-6">
        <Users className="w-5 h-5 text-primary" />
        <h2 className="text-lg font-semibold">Client Acquisition</h2>
      </div>
      <div className="h-[300px]">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}